import moment from 'moment';


export const checkRescheduleData = async (data, props, fetchReferral = false, changeTime = true) => {
    if (!data) return null;
    const tsNow = Math.floor(new Date().getTime() / 1000 + 600);

    let referral;
    if (fetchReferral && data?.referralId && props?.getReferralById) {
        const referralId = data.referralId;
        referral = await props.getReferralById(referralId);
    } else {
        referral = data;
    }

    const status = referral?.status;


    const includedStatuses = [
        "requested-new-appointment",
        "patient-rejected",
        "not-booked",
        "canceled-by-clinic",
        "not-scheduled"
    ];
    if (status && includedStatuses.includes(status)) {
        let rescheduledData = {
            doctorId: null,
            message: null,
            duration: null,
            startTime: null,
            endTime: null
        };
        if (referral?.recipientUser) rescheduledData.doctorId = referral?.recipientUser;
        if (referral?.reason) rescheduledData.message = referral?.reason;
        if (referral?.referralHistory?.length) {
            const referralHistory = referral?.referralHistory;
            // go through the referral history and find the  object which has 'state.event.startTime' and 'state.event.endTime'
            for (let i = referralHistory?.length - 1; i >= 0; i--) {
                const history = referralHistory[i];
                if (history?.state?.event?.startTime && history?.state?.event?.endTime) {
                    rescheduledData.startTime = history.state.event.startTime;
                    rescheduledData.endTime = history.state.event.endTime;
                    rescheduledData.duration = {
                        seconds: rescheduledData.endTime - rescheduledData.startTime,
                        minutes: Math.floor((rescheduledData.endTime - rescheduledData.startTime) / 60)
                    }
                    break;
                }
            }
        }
        data.rescheduledData = rescheduledData;

        if (rescheduledData?.startTime && rescheduledData.endTime && props?.getStringDateTs && changeTime) {

            if (rescheduledData?.startTime > tsNow) {
                data.date = props.getStringDateTs(rescheduledData.startTime, 'YYYY-MM-DD');
                data.endDate = props.getStringDateTs(rescheduledData.startTime, 'YYYY-MM-DD');
                data.startTime = props.getStringDateTs(rescheduledData.startTime, 'HH:mm');
                data.endTime = props.getStringDateTs(rescheduledData.endTime, 'HH:mm');
            } else if (rescheduledData?.duration?.seconds) {
                const durationInSeconds = rescheduledData.duration.seconds;
                data.date = props.getStringDateTs(tsNow, 'YYYY-MM-DD');
                data.endDate = props.getStringDateTs(tsNow, 'YYYY-MM-DD');
                data.startTime = props.getStringDateTs(tsNow, 'HH:mm');
                data.endTime = props.getStringDateTs(tsNow + durationInSeconds, 'HH:mm');
            }
        }

        if (data.rescheduledData?.message) {
            const message = data.rescheduledData.message;
            let rescheduledMessage = ``;
            if (status === "patient-rejected") {
                rescheduledMessage = `${"Reason for cancellation".translate(props.lang)}: ${message}`;
            } else if (status === "requested-new-appointment") {
                rescheduledMessage = `${"Request new time".translate(props.lang)}: ${message}`;
            }
            if (rescheduledMessage) {
                data.rescheduledMessage = rescheduledMessage;
            }
        }


    }

    if (data.startDate !== data?.endDate) {
        data.endDate = data.startDate;
    }
    console.log('data', data)

    return data;
}